
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ski-gear-shipping",
      function () {
        return require("private-next-pages/ski-gear-shipping/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ski-gear-shipping"])
      });
    }
  